import React, { Component } from "react";
import PropTypes from "prop-types";
import Plot from "react-plotly.js";

class GraphDisplay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataset_left: {},
      dataset_right: {},
      budget_dataset_left: {},
      budget_dataset_right: {},
      param1: "null",
      param2: "null",
      xDataYears: [],
    };

    this.handleCostChangeLeft = this.handleCostChangeLeft.bind(this);
    this.handleCostChangeRight = this.handleCostChangeRight.bind(this);
    this.handleChangeLeft = this.handleChangeLeft.bind(this);
    this.handleChangeRight = this.handleChangeRight.bind(this);
  }

  handleCostChangeLeft(event) {
    const { value } = event.target;
    this.setState((prevState) => ({
      param1: value,
      budget_dataset_left: {
        x: this.state.xDataYears.sort((a, b) => {
          return a - b;
        }),
        y: this.props.plotData.cost_data[value],
        name: value,
        mode: "lines+markers",
        type: "scatter",
      },
      param2: prevState.param2,
      budget_dataset_right: prevState.budget_dataset_right,
    }));
  }

  handleCostChangeRight(event) {
    const { value } = event.target;
    this.setState((prevState) => ({
      param1: prevState.param1,
      budget_dataset_right: {
        x: this.state.xDataYears.sort((a, b) => {
          return a - b;
        }),
        y: this.props.plotData.cost_data[value],
        name: value,
        mode: "lines+markers",
        type: "scatter",
      },
      param2: value,
      budget_dataset_left: prevState.budget_dataset_left,
    }));
  }

  handleChangeLeft(event) {
    const { value } = event.target;
    this.setState((prevState) => ({
      param1: value,
      dataset_left: this.props.plotData[value],
      param2: prevState.param2,
      dataset_right: prevState.dataset_right,
    }));
  }

  handleChangeRight(event) {
    const { value } = event.target;

    this.setState((prevState) => ({
      param1: prevState.param1,
      dataset_left: prevState.dataset_left,
      param2: value,
      dataset_right: this.props.plotData[value],
    }));
  }

  componentDidMount = () => {
    let value =
      this.props.plotData.start_year &&
      parseInt(this.props.plotData.start_year);
    const yearArray = [];
    if (this.props.plotData.start_year) {
      while (value !== parseInt(this.props.plotData.end_year) + 1) {
        yearArray.push(value);
        value = value + 1;
      }
      this.setState((prevState) => ({
        xDataYears: yearArray,
      }));
    }
  };

  render() {
    const {
      param1,
      param2,
      dataset_left,
      dataset_right,
      budget_dataset_right,
      budget_dataset_left,
    } = this.state;
    const { singleY, plotData, title, budget_data } = this.props;
    let listItems = [];
    let plotLines = [];

    if (!singleY) {
      listItems =
        this.props.categoryList &&
        this.props.categoryList.map((category) => (
          <option
            key={category.key}
            value={category.key}
            disabled={
              param1 === category.key.toString() ||
              param2 === category.key.toString()
                ? "disabled"
                : ""
            }
          >
            {category.name}
          </option>
        ));
    } else if (budget_data) {
      listItems =
        this.props.categoryList &&
        this.props.categoryList.map((category) => (
          <option key={category} value={category}>
            {category}
          </option>
        ));
    } else {
      if (Array.isArray(title)) {
        plotLines = [
          {
            x: this.state.xDataYears.sort((a, b) => {
              return a - b;
            }),
            y: plotData.data[0],
            name: title[0],
            mode: "lines+markers",
            type: "scatter",
          },
          {
            x: this.state.xDataYears.sort((a, b) => {
              return a - b;
            }),
            y: plotData.data[1],
            name: title[1],
            mode: "lines+markers",
            type: "scatter",
          },
        ];
      } else {
        plotLines = [
          {
            x: this.state.xDataYears.sort((a, b) => {
              return a - b;
            }),
            y: plotData.data,
            name: title,
            mode: "lines+markers",
            type: "scatter",
          },
        ];
      }
    }
    return (
      <div>
        <div id="Plot">
          {singleY &&
            !budget_data && (
              <Plot data={plotLines} layout={this.props.plotLayout} />
            )}
          {!singleY && (
            <Plot
              data={[dataset_left, dataset_right]}
              layout={this.props.plotLayout}
            />
          )}
          {budget_data && (
            <Plot
              data={[budget_dataset_left, budget_dataset_right]}
              layout={this.props.plotLayout}
            />
          )}
        </div>

        {!singleY && (
          <div className="flex flex-50-50">
            <div className="container">
              <span className="leftYAxis">First Parameter</span>:
              <select
                onChange={this.handleChangeLeft}
                className="account__dropDown"
                value={param1}
              >
                <option value="null" disabled>
                  Select a parameter
                </option>
                {listItems}
              </select>
            </div>
            <div className="container">
              <span className="rightYAxis">Second Parameter</span>:
              <select
                onChange={this.handleChangeRight}
                className="account__dropDown"
                value={param2}
              >
                <option value="null" disabled>
                  Select a parameter
                </option>
                {listItems}
              </select>
            </div>
          </div>
        )}
        {budget_data && (
          <div className="flex flex-50-50">
            <div className="container">
              <span className="leftYAxis">First Parameter</span>:
              <select
                onChange={this.handleCostChangeLeft}
                className="account__dropDown"
                value={param1}
              >
                <option value="null" disabled>
                  Select a parameter
                </option>
                {listItems}
              </select>
            </div>
            <div className="container">
              <span className="rightYAxis">Second Parameter</span>:
              <select
                onChange={this.handleCostChangeRight}
                className="account__dropDown"
                value={param2}
              >
                <option value="null" disabled>
                  Select a parameter
                </option>
                {listItems}
              </select>
            </div>
          </div>
        )}
      </div>
    );
  }
}

GraphDisplay.defaultTypes = {
  startYear: 2030,
  endYear: 2044,
  singleY: false,
  title: "",
};

GraphDisplay.propTypes = {
  categoryList: PropTypes.array,
  plotLayout: PropTypes.object.isRequired,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  title: PropTypes.string,
};

export default GraphDisplay;
